import { Box, Typography, Container } from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef, useEffect } from "react";
import { useAnimation } from "../contexts/AnimationContext";

function Introduction({ hasRsvpButtonRendered, onLastBoxAnimationStart }) {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);

  const { animationStarted } = useAnimation();

  const isInView1 = useInView(ref1, { once: true, margin: "0px" });
  const isInView2 = useInView(ref2, { once: true, margin: "0px" });
  const isInView3 = useInView(ref3, { once: true, margin: "0px" });
  const isInView4 = useInView(ref4, { once: true, margin: "0px" });

  useEffect(() => {
    if (
      isInView4 &&
      animationStarted &&
      hasRsvpButtonRendered &&
      onLastBoxAnimationStart
    ) {
      onLastBoxAnimationStart();
    }
  }, [
    isInView4,
    animationStarted,
    hasRsvpButtonRendered,
    onLastBoxAnimationStart,
  ]);

  return (
    <Container maxWidth="md" sx={{ mt: 6, mb: 6 }}>
      <Box
        sx={{
          textAlign: "justify",
          px: { xs: 2, sm: 4, md: 6 },
        }}
      >
        <Typography
          component={motion.p}
          ref={ref1}
          initial={{ opacity: 0, y: 30 }}
          animate={
            isInView1 && animationStarted && hasRsvpButtonRendered
              ? { opacity: 1, y: 0 }
              : { opacity: 0, y: 30 }
          }
          transition={{ duration: 0.8, delay: 0, ease: [0.22, 1, 0.36, 1] }}
          variant="body1"
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: { xs: "1rem", sm: "1.1rem" },
            lineHeight: 2,
            color: "#2d4e66",
            mb: 2,
          }}
        >
          Olá Família e Amigos!
        </Typography>

        <Typography
          component={motion.p}
          ref={ref2}
          initial={{ opacity: 0, y: 30 }}
          animate={
            isInView2 && animationStarted && hasRsvpButtonRendered
              ? { opacity: 1, y: 0 }
              : { opacity: 0, y: 30 }
          }
          transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          variant="body1"
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: { xs: "1rem", sm: "1.1rem" },
            lineHeight: 2,
            color: "#2d4e66",
            mb: 2,
          }}
        >
          Aqui chegámos... A contagem decrescente para o nosso grande dia já
          começou e estamos muito entusiasmados por poder celebrá-lo convosco.
        </Typography>

        <Typography
          component={motion.p}
          ref={ref3}
          initial={{ opacity: 0, y: 30 }}
          animate={
            isInView3 && animationStarted && hasRsvpButtonRendered
              ? { opacity: 1, y: 0 }
              : { opacity: 0, y: 30 }
          }
          transition={{ duration: 0.8, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          variant="body1"
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: { xs: "1rem", sm: "1.1rem" },
            lineHeight: 2,
            color: "#2d4e66",
            mb: 3,
          }}
        >
          E, como não imaginamos viver este momento sem a vossa presença e
          carinho, criámos este site para partilhar todas as informações
          importantes sobre o nosso casamento.
        </Typography>
      </Box>
      <Box
        component={motion.div}
        ref={ref4}
        initial={{ opacity: 0, y: 20 }}
        animate={
          isInView4 && animationStarted && hasRsvpButtonRendered
            ? { opacity: 1, y: 0 }
            : { opacity: 0, y: 20 }
        }
        transition={{ duration: 0.8, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
        sx={{
          textAlign: "right",
          px: { xs: 2, sm: 4, md: 6 },
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: { xs: "1rem", sm: "1.1rem" },
            lineHeight: 2,
            color: "#2d4e66",
            mb: 0,
          }}
        >
          Beijinhos grandes,
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: '"Playfair Display", Georgia, serif',
            fontSize: { xs: "1.1rem", sm: "1.2rem" },
            // fontStyle: "normal",
            lineHeight: 1.8,
            color: "#1a3a52",
            mt: 0,
          }}
        >
          Isabela & Tiago
        </Typography>
      </Box>
    </Container>
  );
}

export default Introduction;
